/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Finnish
export default {
  'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyright': 'Palvelun tuottaa Atlassian Intelligence',
  'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyrightShort': 'Toiminnon tuottaa AI',
  'fabric.editor.ai.commandPalette.footer.disclaimerText':
    'Sisältö perustuu käyttöoikeuksiisi, ja sen laatu voi vaihdella',
  'fabric.editor.ai.commandPalette.footer.disclaimerTextShort': 'Sisällön laatu voi vaihdella',
  'fabric.editor.ai.commandPalette.footer.infoIconLabel': 'Tiedot',
  'fabric.editor.ai.commandPalette.footer.rovoCopyright': 'Rovo',
  'fabric.editor.ai.commandPalette.footer.usePageKnowledgeToggleLabel': 'Ota huomioon nykyisen sivun tiedot',
  'fabric.editor.ai.commandPalette.promptForm.logo': 'Atlassian Intelligence -logo',
  'fabric.editor.ai.components.backIconButton.backLabel': 'Takaisin',
  'fabric.editor.ai.components.cancelEscButton.cancelLabel': 'Peruuta',
  'fabric.editor.ai.components.cancelEscButton.escLabel': 'Esc',
  'fabric.editor.ai.components.cancelIconButton.cancelLabel': 'Peruuta',
  'fabric.editor.ai.components.cancelIconButton.cancelTooltip': 'Peruuta',
  'fabric.editor.ai.components.feedbackForm.badResponse': 'Huono vastaus',
  'fabric.editor.ai.components.feedbackForm.feedbackSent': 'Palaute lähetetty',
  'fabric.editor.ai.components.feedbackForm.goodResponse': 'Hyvä vastaus',
  'fabric.editor.ai.config.item.action.continueFromLatestResponse': 'Jatka viimeisimmästä vastauksesta',
  'fabric.editor.ai.config.item.action.copyResponse': 'Kopioi',
  'fabric.editor.ai.config.item.action.responseCopied': 'Kopioitu!',
  'fabric.editor.ai.config.item.action.responseCopiedToClipboard': 'Kopioitu leikepöydälle',
  'fabric.editor.ai.config.item.action.retryPrompt': 'Yritä uudelleen',
  'fabric.editor.ai.experience-application.documentInsertError':
    'Vastauksen lisääminen ei onnistu. Sulje ikkuna ja yritä uudelleen.',
  'fabric.editor.ai.experience-application.tokenLimitExceeded':
    'Vastausta ei saatu. Kehotteesi tai vastauksesi ylitti tämän pyynnön rajan. Sulje ikkuna ja yritä uudelleen.',
  'fabric.editor.ai.experience.apiError': 'Vastausta ei saatu, yritä uudelleen.',
  'fabric.editor.ai.experience.commandPaletteAriaName': 'Atlassian Intelligence',
  'fabric.editor.ai.experience.inputTooShortError':
    'Sisältö on liian lyhyt yhteenvetoa varten. Lisää sisältöä ja yritä uudelleen.',
  'fabric.editor.ai.experience.loadingAriaTitle': 'Luodaan',
  'fabric.editor.ai.experience.previewScreenLabel': 'Esikatselu',
  'fabric.editor.ai.experience.rovoAgents.agentPalette.placeholder':
    'Pyydä asiakaspalvelijaa kirjoittamaan mitä tahansa tai valitse alta',
  'fabric.editor.ai.experience.rovoAgents.productLabel': 'Rovo',
  'fabric.editor.ai.experience.rovoAgents.productLogoAltText': 'Rovo-logo',
  'fabric.editor.ai.screens.UserInputCommamdPalette.footerText': 'Atlassian Intelligence',
  'fabric.editor.ai.screens.discard.cancelLabel': 'Takaisin',
  'fabric.editor.ai.screens.discard.discardLabel': 'Hylkää',
  'fabric.editor.ai.screens.error.warningIconLabel': 'Varoitus',
  'fabric.editor.ai.screens.error.ariaErrorTitle': 'Virhe',
  'fabric.editor.ai.screens.error.cancelLabel': 'Peruuta',
  'fabric.editor.ai.screens.error.retryLabel': 'Yritä uudelleen',
  'fabric.editor.ai.screens.loading.adfContentAriaLiveRegionDescription': 'Reaaliaikaisesti päivittyvä sisältö:',
  'fabric.editor.ai.screens.loading.iconAltText': 'Luodaan kuvaketta',
  'fabric.editor.ai.screens.preview.betaLabel': 'Beeta',
  'fabric.editor.ai.screens.preview.cancelLabel': 'Peruuta',
  'fabric.editor.ai.screens.preview.defaultAIPlaceholder': 'Kerro AI:lle, mitä tehdä seuraavaksi',
  'fabric.editor.ai.screens.preview.discardLabel': 'Hylkää',
  'fabric.editor.ai.screens.preview.disclaimer': 'Tietojen laatu voi vaihdella.',
  'fabric.editor.ai.screens.preview.disclaimerLink': 'Lue lisää syistä',
  'fabric.editor.ai.screens.preview.header.clear.hover': 'Tyhjennä',
  'fabric.editor.ai.screens.preview.header.edit': 'Muokkaa kehotetta',
  'fabric.editor.ai.screens.preview.header.edit.hover': 'Muokkaa',
  'fabric.editor.ai.screens.preview.placeholderWithAgent':
    'Kysy asiakaspalvelijalta {agentName}, mitä tulisi tehdä seuraavaksi',
  'fabric.editor.ai.screens.preview.refineButton': 'Hio',
  'fabric.editor.ai.screens.preview.refineDropdown.refineButton': 'Hio',
  'fabric.editor.ai.screens.prompt.logoAltText': 'Atlassian Intelligence -logo',
  'fabric.editor.ai.screens.prompt.logoText': 'Atlassian Intelligence',
  'fabric.editor.ai.screens.prompt.submitLabel': 'Lähetä',
  'fabric.editor.ai.screens.prompt.submitTooltip': 'Lähetä AI:lle',
  'fabric.editor.ai.screens.promptWithSelectedOption.promptSelected': '{promptName} valittu',
  'fabric.editor.ai.screens.promptWithSelectedOption.removeLabel': 'Poista',
  'fabric.editor.ai.shared.aiProactiveButtonLabel': 'Ehdotukset',
  'fabric.editor.ai.shared.aiUniversalDescriptor': 'Kirjoitusavustaja',
  'fabric.editor.ai.shared.aiUniversalLongCallToAction': 'Anna Atlassian Intelligencen auttaa kirjoittamisessa',
  'fabric.editor.ai.shared.aiUniversalShortCallToAction': 'Kirjoita',
  'fabric.editor.ai.shared.betaLabel': 'Beeta',
  'fabric.editor.ai.shared.generateContent.aiButtonTitle': 'AI (Atlassian Intelligence)',
  'fabric.editor.ai.ui.components.suggestions.betaLozenge': 'BEETA',
  'fabric.editor.ai.ui.components.suggestions.newLozenge': 'UUSI',
  'fabric.editor.ai.ui.components.suggestions.tellAILabel': 'Sano AI:lle',
  'fabric.editor.ai.ui.components.suggestions.tellAgentLabel': 'Sano asiakaspalvelijalle',
};
